import React from "react"
import {FieldViewProps} from "../../../../render/view";

// const debug = "FieldExpenseStatus_ViewSmall"
const debug = false

export default class FieldExpenseStatus_ViewSmall extends React.Component<FieldViewProps, any> {

    constructor(props:FieldViewProps) {
        super(props)

        this.state = {
            isHovered: false,
            showPopover: false
        }
    }

    render() {
        const status = this.props.model.approvalStatus
        const statusOption = this.props.field.options?.find((option)=>option.value === status)

        return (
            <div className={Classes('ui5-status-list', 'status-c{0}'.f(statusOption?.color), this.props.className)}>
                <div className="max-w-100-percent txt-truncate">{statusOption?.label}</div>
            </div>
        )
    }
}



